import { useIntl } from 'react-intl';
import { ListingFilters } from 'src/components/ListingFilters';
import type { CSSProperties } from 'styled-components';

import { Breadcrumb } from '@/components/Breadcrumb';
import { Container } from '@/components/Container';
import { SectionHeader } from '@/components/SectionHeader';
import { useRouter } from '@/hooks/useRouter';
import { useHasActiveFilters } from '@/integrations/algolia/helpers';
import { commonMessages } from '@/messages/common';
import { theme } from '@/theme';

import type { HeroProductListingProps } from '../../types';

import * as S from './AllTheStrapsType.styles';
import { messages } from './messages';

/**
 * @deprecated doesn't seem to be used anywhere
 */
export const AllTheStrapsType = ({
  backgroundColor,
  backgroundColorOpacity,
  heading,
  media,
  showBreadcrumbs,
  showFilters,
  textAlignment,
}: HeroProductListingProps) => {
  const { paths } = useRouter();
  const { formatMessage } = useIntl();
  const hasActiveFilters = useHasActiveFilters();

  return (
    <>
      <Container
        data-test-id='AllTheStrapsTypeContainer'
        disableGutters
        maxWidth='xl'
      >
        <S.Header
          $backgroundColorOpacity={backgroundColorOpacity}
          backgroundColor={backgroundColor?.value}
          backgroundImage={media?.image?.url}
          data-test-id='AllTheStrapsTypeHeader'
        >
          <Container>
            {showBreadcrumbs && (
              <Breadcrumb
                data-test-id='AllTheStrapsTypeBreadcrumb'
                inverted
                items={[
                  {
                    label: formatMessage(commonMessages.home),
                    target: paths.url(),
                  },
                  {
                    label: formatMessage(commonMessages.straps),
                    target: paths.straps.url(),
                  },
                  {
                    label: formatMessage(messages.strapsAndBracelets),
                    target: paths.straps.all.url(),
                  },
                ]}
              />
            )}
            {heading && (
              <S.Heading data-test-id='AllTheStrapsTypeHeading'>
                <SectionHeader
                  color={theme.colors.primary}
                  colorized={false}
                  data-test-id='AllTheStrapsTypeSectionHeader'
                  sizeDesktop={50}
                  sizeMobile={40}
                  text={heading}
                  textAlign={textAlignment as CSSProperties['textAlign']}
                />
              </S.Heading>
            )}
          </Container>
        </S.Header>
      </Container>
      {showFilters && (
        <ListingFilters
          collectionData={[]}
          data-test-id='AllTheStrapsTypeListingFilters'
          forceMount={hasActiveFilters}
          shouldUpdateVariant
        />
      )}
    </>
  );
};
